export default [
  {
    id: "attributeCategory",
    name: "Attr. category",
  },
  {
    id: "formattedDate",
    name: "Date",
  },
  {
    id: "percentWithAttributes",
    name: " % with attr.",
    numeric: true,
  },
  {
    id: "percentNoAttributeEquities",
    name: " % No attr.",
    numeric: true,
  },
  {
    id: "noAttributeSecurities",
    name: "No attr. securities",
    numeric: true,
  },
]
